import { useEffect, useState } from 'react';
import './App.css';
import Players from './components/Body/Players';
import getplayersData from './Data/PlayersData.json';
import Cart from './components/Cart/cart';
import 'bootstrap/dist/css/bootstrap.css';
import './components/Cart/cart.css'

function App() {
  const [player, setPlayers] = useState([]);
  const [count, setCount] = useState([]);


  //showing data useEffects
  useEffect(()=>{
    const playersData = getplayersData;
    setPlayers(playersData);
  },[])

  //button event handler
    const addHandleClick = (data) =>{
      const newCount = [...count, data]
      setCount(newCount)
    
    }
  return (
    <div className="body">
      <header className="container ">         
                    <h3 className="text-center "> <span>Oh Yea</span> You got {player.length} Players for chose </h3> 
                    <h4 className="text-center mb-5 text-white"> Chose your favorite Players for hire</h4>

           <div className="row">
                <div className="col-sm-8  playersData">
                      {player.map(player => <Players className=" " data = {player} addHandleClick = {addHandleClick} key = {player.id} ></Players> )}
                </div>
                <div className="col-sm-4">
                    <Cart cart = {count}></Cart>
                    
                </div>
           </div>
            
      </header>
    </div>
  );
}

export default App;
